import { lazy, Suspense } from "react";

import CodeEditorLoadingSkeleton from "../CodeEditor/LoadingSkeleton";
import { CodeDiffMonacoProps } from "./Monaco";

type CodeDiffProps = CodeDiffMonacoProps & {
  skeletonCount?: number;
};

const LazyCodeDiffMonaco = lazy(() => import("./Monaco"));

const CodeDiff = (props: CodeDiffProps) => {
  return (
    <Suspense fallback={<CodeEditorLoadingSkeleton skeletonCount={props.skeletonCount} />}>
      <LazyCodeDiffMonaco {...props} />
    </Suspense>
  );
};

export default CodeDiff;
